import { useContext } from 'react';
import * as Input from 'components/input';
import { SelectContext } from 'components/select/SelectContext';
import { SearchableSelectInputProps } from 'components/select/types';

const SearchableSelectInput = (props: SearchableSelectInputProps) => {
    const { inputProps } = useContext(SelectContext);

    return (
        <Input.Root>
            <Input.Form {...props} {...inputProps} />
        </Input.Root>
    );
};

export { SearchableSelectInput };
export type { SearchableSelectInputProps };
